import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, SupplierDto, SupplierReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import SupplierInline, { SupplierInlineProps } from "./SupplierInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: SupplierDto | SupplierReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<SupplierInlineProps>;
}

export default function SupplierLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.SupplierRead]}
      to={ROUTE_PATH.SUPPLIER_VIEW(entity?.id || entityId || "")}
      content={<SupplierInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
